<template>
  <div class="modal offer-modal accept-offer-modal">
    <div class="overlay" @click="$parent.closeAcceptOfferModal"></div>
    <div class="wrapper">
      <img class="close" @click="$parent.closeAcceptOfferModal" src="./../assets/close.svg" />
      <div class="container">
        <div>
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="bottom" v-if="step == 1">
                <div class="title small">Contact information</div>
                <label>
                  <input type="text" placeholder="Name" v-model="name" />
                </label>
                <label>
                  <input type="text" placeholder="Surname" v-model="surname" />
                </label>
                <label>
                  <input type="email" placeholder="E-mail address" v-model="email" />
                </label>
                <label>
                  <input type="tel" placeholder="Phone" v-model="phone" />
                </label>
                <label>
                  <select v-model="country">
                    <option value="" disabled selected>Country</option>
                    <option v-for="(item, i) in countryOptions" :value="item" :key="i">{{ item.title }}</option>
                  </select>
                </label>
                <label>
                  <input type="text" placeholder="City" v-model="city" />
                </label>
                <label>
                  <input type="text" placeholder="Address" v-model="address" />
                </label>
                <label>
                  <input type="text" placeholder="Post Code" v-model="postCode" />
                </label>

                <div class="payout-method-selection">
                  <div class="title small">Choose payout method</div>
                  <div class="buttons">
                    <button 
                      :class="['button', {'disabled': !requiredFieldsAreFilled2}]" 
                      @click="step = 2"
                    >
                      IBAN
                    </button>
                    <button :class="['button blue', { 'disabled': !requiredFieldsAreFilled2 }]" @click="payoutWithCard">
                      Card
                    </button>
                  </div>
                </div>
              </div>

              <div class="bottom" v-if="step == 2">
                <div class="title small">IBAN Transfer</div>
                <label>
                  <input type="text" v-model="bank_holder_name" placeholder="First name" />
                </label>
                <label>
                  <input type="text" v-model="bank_holder_surname" placeholder="Last name" />
                </label>
                <label>
                  <input type="text" maxlength="34" v-model="iban_number" placeholder="IBAN" />
                </label>
                <div class="cta-container">
                  <div class="chekbox-container">
                    <label class="chekbox-label">
                      <div class="chekbox-label-wrapper">
                        <input type="checkbox" name="terms" v-model="terms" />
                        <div class="checkbox"></div>
                        <span class="title">I agree with </span>
                        <a @click="goToPrivacy" class="title"> privacy policy</a>
                        <span class="title"> and </span>
                        <a @click="goToTerms" class="title">terms and conditions</a>
                      </div>
                    </label>
                  </div>
                </div>
              </div>

              <transition name="slide">
                <div v-if="$parent.error" class="error-desc desc red">{{ $parent.error }}</div>
              </transition>

              <div class="buttons">
                <button v-if="step == 1" class="button" @click="goBackToDetails">
                  Back
                </button>

                <button v-if="step == 2" class="button" @click="step = 1">
                  Back
                </button>
                <button v-if="step == 2" :class="['button blue', { 'disabled': !requiredFieldsAreFilled }]"
                  @click="confirmIbanPayout">
                  <span>Confirm</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.payout-method-selection {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.payout-method-selection .title {
  text-align: center;
}

.payout-method-selection .buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.payout-method-selection .buttons .button {
  flex: 1;
  max-width: 150px;
}
</style>

<script>

export default {
  name: 'AcceptOfferModal',
  props: [],
  components: {
  },
  data: function () {
    return {
      step: 1,
      email: '',
      name: '',
      surname: '',
      phone: '',
      country: '',
      countryId: '',
      city: '',
      address: '',
      postCode: '',
      terms: false,
      countryOptions: [],
      countryOptionsId: [],
      bank_holder_name: '',
      bank_holder_surname: '',
      iban_number: '',
    }
  },
  mounted() {
    this.getCounties();
    this.$http.get(process.env.VUE_APP_API + 'user/profile')
      .then((res) => {
        this.email = res.data.email;
        this.name = res.data.name;
        this.surname = res.data.surname;
        this.phone = res.data.phone;
      })
      .catch((res) => {
        if (res.response.status === 401) {
          this.$parent.openSignIn();
        }
      })
  },
  computed: {
    isWithdrawMode() {
      return this.$parent.orderToView && this.$parent.orderToView.status === 'ready_for_payout';
    },
    requiredFieldsAreFilled2() {
      let fieldsAreFilled;
      if (
        this.name && this.surname && this.email && this.phone &&
        this.country && this.city && this.address
        && this.postCode
      ) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    },
    requiredFieldsAreFilled() {
      let fieldsAreFilled;
      if (
        this.name && this.surname && this.email && this.phone &&
        this.country && this.city && this.address
        && this.postCode && this.terms
        && this.bank_holder_name && this.bank_holder_surname
        && this.iban_number
      ) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    }
  },
  methods: {
    goBackToDetails() {
      // Close AcceptOfferModal and reopen OfferDetailsModal without clearing orderToView
      this.$parent.acceptOfferModalIsVisible = false;
      this.$parent.offerDetailsModalIsVisible = true;
      this.$parent.clearError();
    },
    closeAll() {
      this.$parent.closeAcceptOfferModal();
      this.$parent.closeOfferDetailsModal();
    },
    payoutWithCard() {
      if (!this.requiredFieldsAreFilled2) return;

      let data = {
        'id': this.$parent.orderToView.id,
        'name': this.name,
        'surname': this.surname,
        'email': this.email,
        'phone': this.phone,
        'country': (this.country && this.country.iso) || null,
        'city': this.city,
        'address': this.address,
        'postCode': this.postCode,
        'currency': this.$parent.currencyCode
      }

      this.$http.post(process.env.VUE_APP_API + 'offer/request-payout/card', data)
        .then((res) => {
          if (res.data && res.data.redirect_url) {
            window.location.href = res.data.redirect_url;
          } else {
            this.$parent.setError('Could not retrieve payment URL. Please try again.');
          }
        })
        .catch((res) => {
          if (res.response.data.errors) {
            const firstErrors = {};
            for (const key in res.response.data.errors) {
              if (res.response.data.errors.hasOwnProperty(key) && Array.isArray(res.response.data.errors[key]) && res.response.data.errors[key].length > 0) {
                firstErrors[key] = res.response.data.errors[key][0];
                this.$parent.setError(firstErrors[key]);
              }
            }
          } else {
            this.$parent.setError(res.response.data.message);
          }
        })
    },
    confirmIbanPayout() {
      if (!this.requiredFieldsAreFilled) return;

      let data = {
        'id': this.$parent.orderToView.id,
        'account_number': this.iban_number,
        'first_name': this.bank_holder_name,
        'last_name': this.bank_holder_surname,
        'name': this.name,
        'surname': this.surname,
        'email': this.email,
        'phone': this.phone,
        'country': this.country.title || this.country,
        'city': this.city,
        'address': this.address,
        'postCode': this.postCode,
        'currency': this.$parent.currencyCode
      }

      this.$http.post(process.env.VUE_APP_API + 'offer/request-payout/sepa', data)
        .then(() => {
          this.$parent.closeAcceptOfferModal();
          this.$parent.closeOfferDetailsModal();
          // SEPA withdrawal should always go to payout success page
          this.$router.push({ path: '/success-payout' });
        })
        .catch((res) => {
          if (res.response.data.errors) {
            const firstErrors = {};
            for (const key in res.response.data.errors) {
              if (res.response.data.errors.hasOwnProperty(key) && Array.isArray(res.response.data.errors[key]) && res.response.data.errors[key].length > 0) {
                firstErrors[key] = res.response.data.errors[key][0];
                this.$parent.setError(firstErrors[key]);
              }
            }
          } else {
            this.$parent.setError(res.response.data.message);
          }
        })
    },
    goToTerms() {
      this.closeAll();
      this.$parent.goToPage('terms');
    },
    goToPrivacy() {
      this.closeAll();
      this.$parent.goToPage('privacy');
    },
    getCounties() {
      this.$http.get(process.env.VUE_APP_API + 'countries')
        .then((res) => {
          this.countryOptions = res.data.payload;
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
        })
    },
  }
}
</script>
<style scoped>
.form-fields {
  overflow-y: auto;
}
</style>